import { parentEntrySlot } from "./context.js";
import { hasOwnProperty, maybeUnsubscribe, arrayFromSet } from "./helpers.js";
var EntryMethods = {
  setDirty: true,
  dispose: true,
  forget: true // Fully remove parent Entry from LRU cache and computation graph
};
export function dep(options) {
  var depsByKey = new Map();
  var subscribe = options && options.subscribe;
  function depend(key) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
      var _dep = depsByKey.get(key);
      if (!_dep) {
        depsByKey.set(key, _dep = new Set());
      }
      parent.dependOn(_dep);
      if (typeof subscribe === "function") {
        maybeUnsubscribe(_dep);
        _dep.unsubscribe = subscribe(key);
      }
    }
  }
  depend.dirty = function dirty(key, entryMethodName) {
    var dep = depsByKey.get(key);
    if (dep) {
      var m = entryMethodName && hasOwnProperty.call(EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
      // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
      // because modifying a Set while iterating over it can cause elements in
      // the Set to be removed from the Set before they've been iterated over.
      arrayFromSet(dep).forEach(function (entry) {
        return entry[m]();
      });
      depsByKey.delete(key);
      maybeUnsubscribe(dep);
    }
  };
  return depend;
}